export default __webpack_public_path__ + "static/banner_baigun-89df9aa079333df7ab08116847448766.mp4";